import i18n from 'app/locales/i18n';

export const RequiredRules = [
  {
    required: true,
    message: i18n.t('errorRequiredDefault')
  }
];
